import { useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";

const UsePreviousRoute = () => {
  const location = useLocation();
  const prevLocationRef = useRef(null);

  useEffect(() => {
    prevLocationRef.current = location;
  }, [location]);

  return prevLocationRef.current;
};

export default UsePreviousRoute;
